<template>
    <div>
        <div class="text-center" v-if="loader">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
        </div>
        <div v-else>
            <div>
                <v-container>
                    <v-row>
                        <v-col cols="12" md="3">
                            <v-card flat class="d-flex text-center">
                                <v-card-text>
                                    <v-avatar size="112px" v-ripple v-if="actor.thumbnail_url != null" class="mb-3">
                                        <img :src="`${actor.thumbnail_url}`" alt="avatar">
                                    </v-avatar>
                                    <v-avatar size="112px" v-ripple v-else class="grey lighten-3 mb-3">
                                        <span>avatar</span>
                                    </v-avatar>
                                    <h3 v-if="role && (role == 'super administrator' || role == 'administrateur')">{{
                                        actor.first_name }} {{ actor.last_name }}</h3>
                                    <h3>Code Unique : {{ actor.unique_code }}</h3>
                                    <!-- <h3>ID : {{ actor.id }}</h3> -->
                                </v-card-text>
                            </v-card>
                        </v-col>

                        <v-col cols="12" md="3" v-if="actor.card">
                            <v-card flat class="d-flex">
                                <img :src="`/${actor.card.card}`" aspect-ratio="1" class="grey image"
                                    v-if="actor.card.card">
                            </v-card>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-card flat class="d-flex">
                                <v-card-title>Informations personnelles</v-card-title>
                                <v-card-text>
                                    <table class="table show-table" style="width: 100%;">
                                        <tbody>
                                            <tr>
                                                <td>Genre</td>
                                                <td>{{ actor.gender }}</td>
                                            </tr>
                                            <tr>
                                                <td>Age</td>
                                                <td>{{ actor.age }}</td>
                                            </tr>
                                            <tr>
                                                <td>Langue</td>
                                                <td>{{ actor.language }}</td>
                                            </tr>
                                            <tr>
                                                <td>Niveau d'instruction</td>
                                                <td>{{ actor.instruction_level }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-container>
            </div>
            <div>
                <v-card flat class="mt-4">
                    <v-card-title>Informations professionnelles</v-card-title>
                    <v-card-text>
                        <table class="table show-table" style="width: 100%;">
                            <tbody>
                                <tr>
                                    <td>Type d'acteur</td>
                                    <td>{{ actor.type }}</td>
                                </tr>
                                <tr>
                                    <td>Organisation</td>
                                    <td v-if="actor.organization">{{ actor.organization.name }}</td>
                                </tr>
                                <tr>
                                    <td>Maillon</td>
                                    <td v-if="actor.maillon">
                                        {{ actor.maillon.name }}
                                    </td>
                                </tr>
                                <tr>
                                    <td>Chaine de valeur</td>
                                    <td>{{ actor.chain.name }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </v-card-text>
                </v-card>
            </div>
            <div>
                <v-card flat class="mt-4">
                    <v-card-title>Informations de localisation</v-card-title>
                    <v-card-text>
                        <table class="table show-table" style="width: 100%;">
                            <tbody>
                                <tr>
                                    <td>Pays</td>
                                    <td v-if="actor.country">{{ actor.country.name }}</td>
                                </tr>
                                <tr>
                                    <td>Département</td>
                                    <td v-if="actor.department">{{ actor.department.name }}</td>
                                </tr>
                                <tr>
                                    <td>Commune</td>
                                    <td v-if="actor.municipality">{{ actor.municipality.name }}</td>
                                </tr>
                                <tr>
                                    <td>Arrondissement</td>
                                    <td v-if="actor.district">{{ actor.district.name }}</td>
                                </tr>
                                <tr>
                                    <td>Ville/Village</td>
                                    <td v-if="actor.town">{{ actor.town.name }}</td>
                                </tr>
                                <tr>
                                    <td>Adresse physique</td>
                                    <td>{{ actor.address }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </v-card-text>
                </v-card>
            </div>
            <div>
                <v-card flat class="mt-4">
                    <v-card-title>Informations de contact</v-card-title>
                    <v-card-text>
                        <table class="table show-table" style="width: 100%;">
                            <tbody>
                                <tr>
                                    <td>Contact</td>
                                    <td>{{ actor.contact }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </v-card-text>
                </v-card>
            </div>
            <div>
                <v-card flat class="mt-4">
                    <v-card-title>Ajouter par</v-card-title>
                    <v-card-text>
                        <table class="table show-table" style="width: 100%;">
                            <tbody>
                                <tr v-if="actor.user">
                                    <td>Nom Complet</td>
                                    <td>{{ actor.user.profile.first_name }} {{ actor.user.profile.last_name }}</td>
                                </tr>
                                <tr v-if="actor.user">
                                    <td>Email</td>
                                    <td>{{ actor.user.email }}</td>
                                </tr>
                                <tr>
                                    <td>Date d'ajout</td>
                                    <td>{{ actor.created_at }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </v-card-text>
                </v-card>
            </div>
            <div class="mt-6">
                <h3>Evenements suivis</h3>
                <div v-if="actor.events.length > 0">
                    <v-container fluid>
                        <v-row>
                            <v-col v-for="event in actor.events" :key="event.id" class="d-flex child-flex" cols="4">
                                <v-card flat>
                                    <v-card-title>
                                        <v-layout row>
                                            <v-flex xs11 md11>
                                                {{ event.name.length < 70 ? event.name : event.name.substring(0, 70)
                                                    + " ..." }} </v-flex>

                                                    <v-flex x12>
                                                        <h6 class="primary--text">
                                                            <v-icon left>mdi-calendar</v-icon>
                                                            {{ event.event_date | moment("D MMMM YYYY, HH:mm:ss") }}
                                                        </h6>
                                                    </v-flex>

                                        </v-layout>
                                    </v-card-title>

                                    <v-card-text>
                                        <div class="mb-1"> <i>
                                                {{ event.objective.length < 70 ? event.objective :
                                                    event.objective.substring(0, 70) + " ..." }} </i>
                                        </div>

                                        <div>{{ event.type }}</div>

                                        <div class="text-center mt-3">
                                            <!-- <v-chip>{{ event.domain.name }}</v-chip> -->
                                        </div>

                                        <div class="text-center mt-3">
                                            <v-icon>mdi-map-marker</v-icon>
                                            {{ event.place }}
                                            <br>

                                            <v-chip pill color="primary" text-color="white" class="mt-3">
                                                <v-avatar left color="primary darken-2">
                                                    {{ event.actors_count }}
                                                </v-avatar>
                                                participants
                                            </v-chip>

                                        </div>
                                    </v-card-text>

                                </v-card>
                            </v-col>
                        </v-row>
                    </v-container>
                </div>
                <div v-else class="ml-4">No event available here</div>
            </div>
        </div>
    </div>
</template>
<script>
import Permissions from '~/mixins/Permissions'
import axios from 'axios'
export default {
    name: 'actor-show-view',
    mixins: [Permissions],
    data() {
        return {
            loader: false,
            role: '',
            actor: null,
        }
    },
    created() {
        this.$checkPermission('view actors')
        this.fetchActor()
    },
    computed: {
        authUser() {
            return this.$store.getters.authUser;
        },

    },
    methods: {
        async fetchActor() {
            this.loader = true
            const { data } = await axios.get(`/api/actors/${this.$route.params.actorId}`)
            this.actor = data

            if (this.authUser && this.authUser.user && this.authUser.user.roles[0]) {
                this.role = this.authUser.user.roles[0].name
            }
            this.loader = false
        }
    }
}
</script>
<style scoped>
.show-table td,
.show-table th {
    padding: 5px 30px;
}

.image {
    height: 190px;
    width: 210px;
    cursor: pointer;
    margin: 5px;
    display: flex;
    flex-wrap: wrap;
}

tr,
td {
    color: black;
    font-size: 1.1em;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/actors/show.vue